import { Col, Form, Input, message, Spin } from 'antd';
import React, { useRef, useState } from 'react';
import MaskedInput from 'antd-mask-input';
import * as S from './styles';
import LogoVergeGR from '../../../assets/images/logo-verde-tmovgr.svg';
import { postAutoCadastro } from '../../../services/autoCadastro';
import {
  formatarCnpj,
  normalizarCnpj,
  validarCnpj,
  validarCpf,
} from '../../../helpers/utils';
import { PoliticasDeSenha } from '../../../components/PoliticasDeSenha';

export default function Cadastrese({ setRender }) {
  const [senha, setSenha] = useState('');
  function FormItem({
    name,
    label,
    tamanho,
    type,
    required,
    errorMessage,
    passwordInput,
    cpf,
    cnpj,
  }) {
    return (
      <S.wrapperInput tamanho={tamanho}>
        <Form.Item
          name={name}
          normalize={value => (cnpj ? formatarCnpj(value) : value)}
          label={label || 'label'}
          labelAlign="top"
          style={{ margin: '0px' }}
          rules={[
            {
              required: required || false,
              message: errorMessage || 'Por favor preencha este campo.',
            },
          ]}
        >
          {cpf ? (
            <MaskedInput
              mask="000.000.000-00"
              ref={cpfInput}
              placeholder="Digite aqui"
              type={type || 'text'}
              style={{ margin: '16px 0 32px 0', borderRadius: '0' }}
            />
          ) : cnpj ? (
            <Input
              ref={cnpjInput}
              placeholder="Digite aqui"
              type={type || 'text'}
              maxLength={18}
              style={{ margin: '16px 0 32px 0', borderRadius: '0' }}
            />
          ) : (
            <Input
              ref={passwordInput}
              placeholder="Digite aqui"
              type={type || 'text'}
              style={{ margin: '16px 0 32px 0', borderRadius: '0' }}
            />
          )}
        </Form.Item>
      </S.wrapperInput>
    );
  }
  const passwordInput = useRef(null);
  const cpfInput = useRef(null);
  const cnpjInput = useRef(null);
  const [loading, setLoading] = useState(false);

  const salveNewUser = async e => {
    const cnpjNormalizado = normalizarCnpj(e.cnpj);
    const validCnpj = validarCnpj(cnpjNormalizado);
    const validCpf = validarCpf(e.cpf);

    if (e.senha !== e.confirmacaoSenha) {
      passwordInput.current.focus();
      return message.error('As senhas não são iguais.');
    }
    if (cnpjNormalizado.length !== 14) {
      cnpjInput.current.focus();
      return message.error('CNPJ incompleto.');
    }
    if (e.cpf.includes('_')) {
      cpfInput.current.focus();
      return message.error('CPF incompleto.');
    }

    if (!validCnpj) {
      return message.error('CNPJ Inválido.');
    }

    if (!validCpf) {
      return message.error('CPF Inválido.');
    }

    setLoading(true);
    try {
      await postAutoCadastro({
        e: {
          ...e,
          cnpj: cnpjNormalizado,
        },
      });
      setRender('WelcomeSuccess');
      setLoading(false);
    } catch (error) {
      if (error.response) {
        message.error(error.response.data.detail);
      } else {
        message.error('Erro ao criar um novo usuário.');
      }
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Spin
        spinning={loading}
        size="large"
        style={{
          position: 'fixed',
          zIndex: 999,
        }}
        tip="Carregando..."
      >
        <Form layout="vertical" name="form" onFinish={salveNewUser}>
          <S.DivForm>
            <Col type="flex" align="middle" justify="center">
              <img
                src={LogoVergeGR}
                alt="logo tmovGr"
                style={{ width: '225px', height: '66px' }}
              />
            </Col>
            <p
              style={{
                margin: '32px',
                fontSize: '18px',
                color: '#000',
                display: 'flex',
                alignItems: 'center',
                placeContent: 'center',
              }}
            >
              Preencha os dados abaixo para se cadastrar!
            </p>
            <S.Separator>
              <FormItem
                tamanho="70%"
                required
                errorMessage="Insira um nome."
                name="nome"
                label="Nome*"
              />
              <FormItem
                tamanho="30%"
                required
                cpf={true}
                errorMessage="Insira um CPF."
                name="cpf"
                label="CPF*"
              />
            </S.Separator>
            <S.Separator>
              <FormItem
                tamanho="30%"
                required
                cnpj={true}
                errorMessage="Insira um CNPJ."
                name="cnpj"
                label="CNPJ*"
              />
              <FormItem
                tamanho="70%"
                required
                errorMessage="Insira um E-mail."
                type="email"
                name="email"
                label="E-mail*"
              />
            </S.Separator>
            <S.Separator>
              <S.wrapperInput tamanho="50%">
                <Form.Item
                  name="senha"
                  label="Senha*"
                  labelAlign="top"
                  style={{ margin: '0px' }}
                  autofocus={true}
                  rules={[
                    {
                      required: true,
                      message: 'Insira uma Senha.',
                    },
                  ]}
                >
                  <Input
                    ref={passwordInput}
                    placeholder="Digite aqui"
                    type="password"
                    style={{ margin: '16px 0 32px 0', borderRadius: '0' }}
                    onChange={e => setSenha(e.currentTarget.value)}
                  />
                </Form.Item>
              </S.wrapperInput>
              <FormItem
                tamanho="50%"
                type="password"
                name="confirmacaoSenha"
                label="Confirmar senha*"
                required
                errorMessage="Confirme a sua Senha."
                autofocus={false}
              />
            </S.Separator>
            <S.Separator>
              <PoliticasDeSenha senha={senha} />
            </S.Separator>
            <S.SeparatorButton>
              <Form.Item>
                <S.ButtonCancel
                  type="reset"
                  onClick={() => setRender('CorpoLogin')}
                >
                  Cancelar
                </S.ButtonCancel>
              </Form.Item>
              <Form.Item>
                <S.ButtonSave type="submit">Salvar</S.ButtonSave>
              </Form.Item>
            </S.SeparatorButton>
          </S.DivForm>
        </Form>
      </Spin>
    </div>
  );
}
